<p-columnFilter [field]=field display="menu" #filterId [showAddButton]="false" [showMatchModes]="false" matchMode="custom-equals"
    [showOperator]="false" [showClearButton]="false" [showApplyButton]="false"
    (click)="filterOpen(filterFormGroup, field, 'matchModeControl');">
    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
        <form [formGroup]="filterFormGroup" (keydown.enter)="apply(filterFormGroup, field);filterId.hide()">
            <p-dropdown [options]="matchModeOptions" formControlName="matchModeControl" optionLabel="label"
                optionValue="value"></p-dropdown>
            <p-multiSelect [options]="values"  [ngModelOptions]="{standalone: true}" [optionLabel]="optionLabel" styleClass="mt-1"
                [optionValue]="optionValue" [(ngModel)]="selectedIds" (ngModelChange)='onChange($event)' (onChange)="getSelectedIdsOnChange($event)" display="chip"></p-multiSelect>
            <div class="d-flex justify-content-around mt-3">
                <button type="button" class="btn btn-danger btn-sm column-filter-btn" pRipple
                    (click)="clear(field);filterId.hide();initialSetup()">Clear</button>
                <button type="button" class="btn btn-success btn-sm column-filter-btn" pRipple
                    (click)="apply(filterFormGroup, field);filterId.hide()">Apply</button>
            </div>
        </form>
    </ng-template>
</p-columnFilter>